/* Model */
class PaymentMethodTypeModel extends App.Models.BaseModel {
  modelUrl = 'PaymentMethodType';
}

App.Models.PaymentMethodType = PaymentMethodTypeModel;

/* Collection */
class PaymentMethodTypeCollection extends App.Collections.BaseCollection {
  url = 'PaymentMethodType';
  model = App.Models.PaymentMethodType;
}

App.Collections.PaymentMethodTypes = PaymentMethodTypeCollection;

/* Router */
class PaymentMethodTypeRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'PaymentMethodType';
      const model = App.Models.PaymentMethodType;
      const collectionClass = App.Collections.PaymentMethodTypes;

      super(entityName, model, collectionClass);
  }
}

App.Routers.PaymentMethodType = PaymentMethodTypeRouter;